import React from 'react'
// import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom';

import { MainLayout, SideBarLayout } from '../../layouts';
import { baseUrl } from '../../config/baseUrl';
import { 
  ApisSideBar, 
  ApiIntroduction,
  ApiAuthentication,
  MakingRequests,
  ResponseDefinition,
  UserRegister,
  UserLogin,
  FindNearSegments,
  Direct,
  GetTrafficStatus,
  Report,
  References,
  Notification,
  Distance,
  Application,
  Feedback,
} from './components';

const Apis = props => {
  const apiSideBar = <ApisSideBar />;
  return (
    <MainLayout>
      <SideBarLayout sideBar={apiSideBar}>
        <Switch>
          <Route path={`${baseUrl}apis/intro`} exact component={ApiIntroduction} />
          <Route path={`${baseUrl}apis/intro/auth`} exact component={ApiAuthentication} />
          <Route path={`${baseUrl}apis/intro/making-requests`} exact component={MakingRequests} />
          <Route path={`${baseUrl}apis/intro/response-definition`} exact component={ResponseDefinition} />
          <Route path={`${baseUrl}apis/user-auth/register`} exact component={UserRegister} />
          <Route path={`${baseUrl}apis/user-auth/login`} exact component={UserLogin} />
          <Route path={`${baseUrl}apis/map/find-near-segments`} exact component={FindNearSegments} />
          <Route path={`${baseUrl}apis/map/direct`} exact component={Direct} />
          <Route path={`${baseUrl}apis/status/get-traffic-status`} exact component={GetTrafficStatus} />
          <Route path={`${baseUrl}apis/status/report`} exact component={Report} />
          <Route path={`${baseUrl}apis/references`} exact component={References} />
          <Route path={`${baseUrl}apis/notification`} exact component={Notification} />
          <Route path={`${baseUrl}apis/distance`} exact component={Distance} />
          <Route path={`${baseUrl}apis/application`} exact component={Application} />
          <Route path={`${baseUrl}apis/feedback`} exact component={Feedback} />
        </Switch>
      </SideBarLayout>
    </MainLayout>
  )
}

Apis.propTypes = {

}

export default Apis
